<template>
  <div style="margin-top:-100%; z-index: 0">
    <svg
      v-if="preferencias.hair=='hair1'"
      viewBox="0 0 600 600"
      style="enable-background:new 0 0 600 600;"
      xml:space="preserve"
    >
      <path
        class="st0"
        :style="preferencias.color"
        d="M314,143.5c0,0-22.9,0-36.8-26.8c-5.3-10.3-9.9-30.4,7.6-46c0,0-70,13.1-54.1,72.8c0.8,3.1,1.8,5.9,3.1,8.5
                        c-2.9-1.6-5.9-3.8-9-6.7c-6.6-6.3-15.2-20-6.3-36.2c0,0-48.6,27.8-21.4,68.1c26.7,39.5,107,2.2,128.5-8.9c0.6-0.3,1.2-0.5,1.8-0.8
                        c5.2-3.2,10.5-6.7,16.1-10.5c0.6-0.6,1.2-1.2,1.7-1.9c1.5-1.8,2.6-3.6,3-5.4C348.2,149.7,328.5,142.5,314,143.5z"
      />
      <path
        class="st1"
        d="M268.2,85.4c0,0-0.7,1-1.5,2.9c-0.9,1.9-2,4.7-2.7,8.1c-0.7,3.4-1.1,7.5-0.4,11.7c0.3,2.1,0.8,4.2,1.6,6.4
                        c0.7,2.1,1.7,4.2,2.8,6.2c0.5,1,1.2,2,1.7,3c0.7,0.9,1.3,1.9,2,2.8s1.4,1.8,2.1,2.7c0.7,0.8,1.5,1.7,2.2,2.5c1.5,1.6,3,3.2,4.5,4.5
                        c1.5,1.4,2.9,2.7,4.3,3.9c1.3,1.2,2.6,2.2,3.7,3.2s2.1,1.7,3,2.4c1.7,1.3,2.6,2.1,2.6,2.1s-1.1-0.5-3-1.4c-1-0.5-2.1-1-3.4-1.8
                        c-1.3-0.7-2.8-1.5-4.3-2.6c-1.5-1-3.2-2.1-4.9-3.4c-1.7-1.2-3.4-2.7-5.1-4.3c-0.8-0.8-1.7-1.7-2.5-2.5c-0.8-0.9-1.6-1.8-2.4-2.8
                        c-0.7-1-1.5-2-2.2-3c-0.7-1.1-1.4-2.1-2-3.2c-1.2-2.3-2.3-4.6-3-7c-0.8-2.4-1.2-4.9-1.4-7.3c-0.2-2.4,0-4.7,0.3-6.9
                        c0.3-2.2,0.9-4.1,1.5-5.9c1.3-3.5,3-6.2,4.3-7.9C267.3,86.2,268.2,85.4,268.2,85.4z"
      />
      <path
        class="st1"
        d="M261.5,141.9c0,0,0.8,0.7,2.2,1.8c0.7,0.5,1.6,1.2,2.6,1.9c1,0.7,2.2,1.5,3.4,2.3c1.3,0.8,2.7,1.6,4.2,2.4
                        c0.8,0.4,1.6,0.8,2.4,1.2c0.8,0.4,1.7,0.7,2.5,1.1c1.7,0.8,3.5,1.3,5.4,2.1c1.8,0.6,3.8,1.1,5.7,1.7c1.9,0.4,3.9,1,5.8,1.2
                        c1.9,0.2,3.8,0.7,5.7,0.9c1.9,0.1,3.7,0.3,5.4,0.5c1.7,0.1,3.4,0.1,4.9,0.2s2.9,0.2,4.2,0.1c1.2,0,2.3,0,3.2,0
                        c1.8,0,2.9,0.1,2.9,0.1s-1,0.3-2.7,0.8c-0.9,0.2-2,0.5-3.2,0.8s-2.6,0.6-4.2,0.7c-1.6,0.2-3.2,0.4-5,0.5c-1.8,0-3.7,0.1-5.7,0
                        s-4-0.3-6.1-0.5c-2.1-0.3-4.1-0.8-6.2-1.2c-2-0.6-4.1-1.2-6-1.9c-1.9-0.8-3.8-1.6-5.6-2.5c-0.9-0.5-1.8-0.9-2.6-1.4
                        c-0.8-0.5-1.6-1-2.3-1.5c-1.5-1-2.8-2.1-4-3.1c-1.2-1.1-2.2-2.1-3.1-3c-0.9-0.9-1.5-1.8-2.1-2.5C262,142.9,261.5,141.9,261.5,141.9z
                        "
      />
      <path
        class="st1"
        d="M206.6,129.1c0,0-0.7,1.3-1.6,3.6c-0.5,1.2-1,2.6-1.4,4.3c-0.2,0.8-0.5,1.7-0.6,2.7c-0.2,0.9-0.4,1.9-0.5,3
                        c-0.3,2.1-0.3,4.3-0.2,6.7c0.1,1.2,0.3,2.4,0.5,3.6c0.4,1.2,0.5,2.4,0.9,3.6c0.8,2.4,1.9,4.8,3.3,7.1l1.1,1.7l0.3,0.4v0.1
                        c-0.2-0.2,0-0.1-0.1-0.1l0,0l0.1,0.1l0.2,0.2l0.7,0.8c0.9,1.1,1.8,2.3,2.8,3.1c1,0.9,1.8,1.8,3,2.6c1.1,0.8,2.2,1.6,3.4,2.2
                        c1.2,0.7,2.3,1.4,3.6,1.9c1.2,0.6,2.4,1.2,3.6,1.6c4.9,1.9,9.7,3.1,13.9,3.9c2.1,0.4,4.1,0.7,5.8,0.9s3.3,0.4,4.5,0.5
                        c2.5,0.3,4,0.3,4,0.3s-0.4,0.1-1,0.2c-0.7,0.1-1.7,0.3-2.9,0.4c-1.3,0.1-2.8,0.2-4.6,0.3c-0.9,0-1.8,0-2.8,0s-2.1-0.1-3.2-0.1
                        c-2.2-0.2-4.6-0.4-7.1-0.9s-5.1-1-7.8-1.9c-1.4-0.4-2.7-1-4-1.5c-1.4-0.5-2.7-1.2-4-1.9s-2.6-1.6-3.8-2.4c-1.3-0.8-2.4-1.9-3.6-3
                        c-1.3-1.1-2.1-2.2-3-3.3l-0.7-0.8l-0.2-0.2l-0.1-0.1l-0.1-0.2v-0.1l-0.3-0.5l-1.2-1.9c-0.9-1.2-1.4-2.7-2-4c-0.7-1.3-1-2.8-1.4-4.1
                        c-0.4-1.4-0.6-2.8-0.8-4.2c-0.1-1.4-0.2-2.7-0.2-4c0.1-2.6,0.4-5.1,1-7.2c0.5-2.2,1.3-4.1,2-5.7c0.7-1.7,1.5-3,2.2-4.1
                        C205.6,130.1,206.6,129.1,206.6,129.1z"
      />
      <path
        class="st0"
        :style="preferencias.color"
        d="M343.5,157c-5.6,3.8-10.9,7.3-16.1,10.5C334.1,164.3,339.7,160.6,343.5,157z"
      />
      <path
        class="st1"
        d="M197.1,177.2c0,0,23.8,56.4,130.3-9.8c-0.6,0.3-1.2,0.6-1.8,0.8C304.1,179.4,223.8,216.7,197.1,177.2z"
      />
      <path
        class="st1"
        d="M343.5,157C343.5,157,343.5,157,343.5,157c1.1-0.8,1.7-1.4,1.7-1.9C344.7,155.7,344.1,156.3,343.5,157z"
      />
    </svg>

    <svg
      v-if="preferencias.hair=='hair2'"
      :style="preferencias.color"
      viewBox="0 0 600 600"
      style="enable-background:new 0 0 600 600;"
      xml:space="preserve"
    >
<path class="st0" d="M299.4,175.1c58.7,0,110.5,33.3,141.4,84c1.8-8.9,2.9-19.9,1.7-32.6c0,0-4.8,4.5-6.2,12.9
	c1.1-11.7,3.8-55.7-13.3-92.6c0,0-3.1,12.2-1.5,24.1c-3.1-14.8-13.9-58.9-36.9-83.9c0,0-1.3,11.1,1.3,17.8
	c-4.4-8.4-20.7-38.2-37.7-50.1c0,0-2.9,12.7,1.1,15.4c0,0-12.6-8.6-15.1-22.2c0,0-5.8-0.5-2.9,12.9c0,0-18.5-6.2-31.9-6.2
	S267.5,61,267.5,61c2.9-13.4-2.9-12.9-2.9-12.9c-2.5,13.5-15.1,22.2-15.1,22.2c4-2.7,1.1-15.4,1.1-15.4
	c-17,11.9-33.3,41.7-37.7,50.1c2.6-6.7,1.3-17.8,1.3-17.8c-23,25-33.8,69.1-36.9,83.9c1.6-11.9-1.5-24.1-1.5-24.1
	c-17.1,36.9-14.4,80.9-13.3,92.6c-1.3-8.4-6.2-12.9-6.2-12.9c-1.1,12.5-0.1,23.5,1.7,32.4C189,208.3,240.8,175.1,299.4,175.1z"/>
<path class="st2" d="M256.9,179.5c0,0-0.5-0.9-1.1-2.4c-0.6-1.6-1.4-3.9-1.9-6.7c-0.5-2.8-0.7-6.2-0.3-9.7c0.2-1.8,0.6-3.5,1.1-5.3
	c0.5-1.8,1.2-3.5,2-5.1c0.4-0.8,0.8-1.6,1.2-2.5c0.5-0.8,0.9-1.6,1.4-2.3c0.5-0.7,1-1.5,1.5-2.2c0.5-0.7,1-1.4,1.6-2.1
	c1.1-1.3,2.1-2.6,3.2-3.8c1-1.2,2.1-2.2,3-3.2c0.9-1,1.9-1.8,2.6-2.6c0.8-0.8,1.5-1.4,2.1-2c1.2-1.1,1.8-1.8,1.8-1.8
	s-0.8,0.4-2.1,1.2c-0.7,0.4-1.5,0.8-2.4,1.5c-0.9,0.6-2,1.2-3,2.1c-1.1,0.8-2.3,1.7-3.4,2.8c-1.2,1-2.4,2.3-3.6,3.6
	c-0.6,0.7-1.2,1.4-1.8,2.1c-0.6,0.7-1.1,1.5-1.7,2.3c-0.5,0.8-1,1.7-1.6,2.5c-0.5,0.9-1,1.8-1.4,2.7c-0.8,1.9-1.6,3.8-2.1,5.8
	c-0.6,2-0.8,4-1,6c-0.2,2,0,3.9,0.2,5.7c0.2,1.8,0.6,3.4,1.1,4.9c0.9,2.9,2.1,5.1,3.1,6.5C256.2,178.8,256.9,179.5,256.9,179.5z"/>
<path class="st2" d="M215.9,203.8c0,0,0.5-0.6,1.5-1.5c0.5-0.4,1.1-1,1.8-1.6c0.7-0.6,1.5-1.2,2.4-1.9c0.9-0.6,1.9-1.3,3-2
	c0.5-0.3,1.1-0.6,1.7-1c0.6-0.3,1.2-0.6,1.8-0.9c1.2-0.7,2.5-1.1,3.8-1.7c1.3-0.5,2.7-0.9,4-1.4c1.4-0.3,2.7-0.8,4.1-1
	c1.4-0.2,2.7-0.6,4-0.7c1.3-0.1,2.6-0.3,3.8-0.4c1.2-0.1,2.4-0.1,3.5-0.2c1.1-0.1,2.1-0.1,2.9-0.1c0.9,0,1.7,0,2.3,0
	c1.3,0,2-0.1,2-0.1s-0.7-0.3-1.9-0.6c-0.6-0.2-1.4-0.4-2.3-0.6c-0.9-0.3-1.9-0.5-3-0.6c-1.1-0.2-2.3-0.4-3.6-0.4c-1.3,0-2.6-0.1-4,0
	c-1.4,0.1-2.8,0.2-4.3,0.4c-1.5,0.2-2.9,0.7-4.4,1c-1.4,0.5-2.9,1-4.3,1.6c-1.4,0.7-2.7,1.3-3.9,2.1c-0.6,0.4-1.2,0.7-1.8,1.2
	c-0.6,0.4-1.1,0.9-1.7,1.3c-1.1,0.8-2,1.8-2.9,2.6c-0.8,0.9-1.6,1.7-2.2,2.5c-0.6,0.8-1.1,1.5-1.5,2.1
	C216.2,203,215.9,203.8,215.9,203.8z"/>
<path class="st2" d="M201.2,201.4c0,0-0.5-1.1-1.2-3c-0.3-1-0.7-2.2-1-3.5c-0.2-0.7-0.3-1.4-0.5-2.2c-0.1-0.8-0.3-1.6-0.4-2.5
	c-0.2-1.7-0.2-3.6-0.2-5.6c0.1-1,0.2-2,0.3-3c0.2-1,0.3-2,0.7-3c0.6-2,1.3-4,2.4-5.9l0.8-1.4l0.2-0.4l0,0c-0.1,0.2,0,0-0.1,0.1l0,0
	l0.1-0.1l0.1-0.2l0.5-0.7c0.7-0.9,1.3-1.9,2-2.5c0.7-0.7,1.3-1.5,2.1-2.1c0.8-0.7,1.5-1.4,2.4-1.9c0.8-0.5,1.6-1.1,2.5-1.6
	c0.9-0.5,1.7-1,2.6-1.3c3.5-1.6,6.9-2.6,9.8-3.2c1.5-0.3,2.9-0.6,4.1-0.8c1.2-0.2,2.3-0.3,3.2-0.4c1.8-0.2,2.8-0.3,2.8-0.3
	s-0.3,0-0.7-0.1c-0.5-0.1-1.2-0.2-2.1-0.3c-0.9-0.1-2-0.2-3.3-0.2c-0.6,0-1.3,0-2,0c-0.7,0-1.5,0.1-2.2,0.1c-1.6,0.1-3.2,0.3-5,0.7
	c-1.8,0.4-3.6,0.8-5.5,1.6c-1,0.3-1.9,0.8-2.8,1.2c-1,0.4-1.9,1-2.8,1.6c-0.9,0.5-1.8,1.3-2.7,2c-0.9,0.7-1.7,1.6-2.6,2.5
	c-0.9,0.9-1.5,1.8-2.1,2.8l-0.5,0.7l-0.1,0.2l-0.1,0.1L200,169l0,0.1l-0.2,0.4L199,171c-0.6,1-1,2.2-1.4,3.3c-0.5,1.1-0.7,2.3-1,3.4
	c-0.3,1.1-0.4,2.3-0.6,3.4c-0.1,1.1-0.1,2.3-0.1,3.3c0.1,2.2,0.3,4.2,0.7,6c0.4,1.8,0.9,3.4,1.4,4.8c0.5,1.4,1.1,2.5,1.6,3.4
	C200.5,200.6,201.2,201.4,201.2,201.4z"/>
<path class="st2" d="M369.9,227.3c0,0-0.5-0.9-1.1-2.4c-0.6-1.6-1.4-3.9-1.9-6.7c-0.5-2.8-0.7-6.2-0.3-9.7c0.2-1.8,0.6-3.5,1.1-5.3
	c0.5-1.8,1.2-3.5,2-5.1c0.4-0.8,0.8-1.6,1.2-2.5c0.5-0.8,0.9-1.6,1.4-2.3c0.5-0.7,1-1.5,1.5-2.2c0.5-0.7,1-1.4,1.6-2.1
	c1.1-1.3,2.1-2.6,3.2-3.8c1-1.2,2.1-2.2,3-3.2c0.9-1,1.9-1.8,2.6-2.6c0.8-0.8,1.5-1.4,2.1-2c1.2-1.1,1.8-1.8,1.8-1.8
	s-0.8,0.4-2.1,1.2c-0.7,0.4-1.5,0.8-2.4,1.5c-0.9,0.6-2,1.2-3,2.1c-1.1,0.8-2.3,1.7-3.4,2.8c-1.2,1-2.4,2.3-3.6,3.6
	c-0.6,0.7-1.2,1.4-1.8,2.1c-0.6,0.7-1.1,1.5-1.7,2.3c-0.5,0.8-1,1.7-1.6,2.5c-0.5,0.9-1,1.8-1.4,2.7c-0.8,1.9-1.6,3.8-2.1,5.8
	c-0.6,2-0.8,4-1,6c-0.2,2,0,3.9,0.2,5.7c0.2,1.8,0.6,3.4,1.1,4.9c0.9,2.9,2.1,5.1,3.1,6.5C369.2,226.7,369.9,227.3,369.9,227.3z"/>
<path class="st2" d="M334.6,158.7c0,0,0.5-0.6,1.5-1.5c0.5-0.4,1.1-1,1.8-1.6c0.7-0.6,1.5-1.2,2.4-1.9c0.9-0.6,1.9-1.3,3-2
	c0.5-0.3,1.1-0.6,1.7-1c0.6-0.3,1.2-0.6,1.8-0.9c1.2-0.7,2.5-1.1,3.8-1.7c1.3-0.5,2.7-0.9,4-1.4c1.4-0.3,2.7-0.8,4.1-1
	c1.4-0.2,2.7-0.6,4-0.7c1.3-0.1,2.6-0.3,3.8-0.4c1.2-0.1,2.4-0.1,3.5-0.2c1.1-0.1,2.1-0.1,2.9-0.1c0.9,0,1.7,0,2.3,0
	c1.3,0,2-0.1,2-0.1s-0.7-0.3-1.9-0.6c-0.6-0.2-1.4-0.4-2.3-0.6c-0.9-0.3-1.9-0.5-3-0.6c-1.1-0.2-2.3-0.4-3.6-0.4c-1.3,0-2.6-0.1-4,0
	c-1.4,0.1-2.8,0.2-4.3,0.4c-1.5,0.2-2.9,0.7-4.4,1c-1.4,0.5-2.9,1-4.3,1.6c-1.4,0.7-2.7,1.3-3.9,2.1c-0.6,0.4-1.2,0.7-1.8,1.2
	c-0.6,0.4-1.1,0.9-1.7,1.3c-1.1,0.8-2,1.8-2.9,2.6c-0.8,0.9-1.6,1.7-2.2,2.5c-0.6,0.8-1.1,1.5-1.5,2.1
	C335,157.9,334.6,158.7,334.6,158.7z"/>
<path class="st2" d="M294.5,190.9c0,0-0.5-1.1-1.2-3c-0.3-1-0.7-2.2-1-3.5c-0.2-0.7-0.3-1.4-0.5-2.2c-0.1-0.8-0.3-1.6-0.4-2.5
	c-0.2-1.7-0.2-3.6-0.2-5.6c0.1-1,0.2-2,0.3-3c0.2-1,0.3-2,0.7-3c0.6-2,1.3-4,2.4-5.9l0.8-1.4l0.2-0.4l0,0c-0.1,0.2,0,0-0.1,0.1l0,0
	l0.1-0.1l0.1-0.2l0.5-0.7c0.7-0.9,1.3-1.9,2-2.5c0.7-0.7,1.3-1.5,2.1-2.1c0.8-0.7,1.5-1.4,2.4-1.9c0.8-0.5,1.6-1.1,2.5-1.6
	c0.9-0.5,1.7-1,2.6-1.3c3.5-1.6,6.9-2.6,9.8-3.2c1.5-0.3,2.9-0.6,4.1-0.8c1.2-0.2,2.3-0.3,3.2-0.4c1.8-0.2,2.8-0.3,2.8-0.3
	s-0.3,0-0.7-0.1c-0.5-0.1-1.2-0.2-2.1-0.3c-0.9-0.1-2-0.2-3.3-0.2c-0.6,0-1.3,0-2,0c-0.7,0-1.5,0.1-2.2,0.1c-1.6,0.1-3.2,0.3-5,0.7
	c-1.8,0.4-3.6,0.8-5.5,1.6c-1,0.3-1.9,0.8-2.8,1.2c-1,0.4-1.9,1-2.8,1.6c-0.9,0.5-1.8,1.3-2.7,2c-0.9,0.7-1.7,1.6-2.6,2.5
	c-0.9,0.9-1.5,1.8-2.1,2.8l-0.5,0.7l-0.1,0.2l-0.1,0.1l-0.1,0.1l0,0.1l-0.2,0.4l-0.8,1.6c-0.6,1-1,2.2-1.4,3.3
	c-0.5,1.1-0.7,2.3-1,3.4c-0.3,1.1-0.4,2.3-0.6,3.4c-0.1,1.1-0.1,2.3-0.1,3.3c0.1,2.2,0.3,4.2,0.7,6c0.4,1.8,0.9,3.4,1.4,4.8
	c0.5,1.4,1.1,2.5,1.6,3.4C293.8,190,294.5,190.9,294.5,190.9z"/>
<path class="st1" d="M349.1,150c-5,3.8-9.7,7.3-14.3,10.5C340.8,157.3,345.8,153.6,349.1,150z"/>
<path class="st1" d="M349.1,150L349.1,150c1-0.8,1.5-1.4,1.5-1.9C350.2,148.7,349.7,149.3,349.1,150z"/>
    </svg>

    <img v-if="preferencias.hair == 'hair3'" :src="'../public/images/arkidians/hair3.svg'" />
        <img v-if="preferencias.hair == 'hair4'" :src="'../public/images/arkidians/hair4.svg'" />

  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  methods: {},
  props: ["preferencias"],

  mounted: function() {}
};
</script>

<style scoped>
.st1 {
  opacity: 0.18;
  enable-background: new;
}
.st2 {
  opacity: 0.11;
  enable-background: new;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/Hair.vue